export default __webpack_public_path__ + "static/media/ILUSTRACIONES_05.222e9945.png";